<template>
  <div class="search_bar_input--inner-button t-sm"
    v-tooltip.bottom="isEmpty(currentExcludes) ?
      'Exclude results with specific words or phrases' :
      `Exclude <b>${currentExcludes.join(', ')}</b>`"
  >
    <button
      class="btn btn-sm py-0 t-600"
      :class="!isEmpty(currentExcludes) ? 'btn-primary' : 'btn-outline-primary'"
      type="button"
      @click="$events.$emit('modal:exclude', currentExcludes)"
      v-html="`${isEmpty(currentExcludes) ?
        'Exclude...' :
        `Exclude <span class='ml-1 semi-transparent'>${currentExcludes.length}</span>` }
      `"
    />
  </div>
</template>

<script>
export default {
  name: 'excludeButton',
  props: {
    currentExcludes: {
      type: Array,
      required: true
    }
  },
  mounted () {
    // Apply exclude terms
    this.$events.$on('excludes:update', (excludes) => {
      this.$emit('setExcludes', excludes)
    })
  },
  destroyed () {
    this.$events.$off('excludes:update')
  }
}
</script>
